import { render, staticRenderFns } from "./MyHero.vue?vue&type=template&id=6151bcfe&scoped=true&"
import script from "./MyHero.vue?vue&type=script&lang=js&"
export * from "./MyHero.vue?vue&type=script&lang=js&"
import style0 from "./MyHero.vue?vue&type=style&index=0&id=6151bcfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151bcfe",
  null
  
)

export default component.exports